import React from 'react'

export default function Footer() {
  return (
    <div className='text-secondary-500 bg-primary-700 py-10 w-full flex items-center justify-center'>Diseño y Desarrollo por Carolina Bilkis</div>
  )
}
